import { render } from "./TheTypeOfCode.vue?vue&type=template&id=343cd2fe&scoped=true&ts=true&lang=html"
import script from "./TheTypeOfCode.vue?vue&type=script&lang=ts"
export * from "./TheTypeOfCode.vue?vue&type=script&lang=ts"

import "./TheTypeOfCode.vue?vue&type=style&index=0&id=343cd2fe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343cd2fe"]])

export default __exports__